import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import styles from './PricingFAQSection.module.scss';

export default class PricingFAQSection extends Component {
  static propTypes = {
    className: PropTypes.string,
    leftTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    rightTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    leftText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    rightText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  constructor() {
    super();

    this.state = {
      visible: false,
    };
  }

  render() {
    const { className, leftTitle, rightTitle, leftText, rightText, ...rest } =
      this.props;

    const { visible } = this.state;

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div className={className ? ' ' + className : ''} {...rest}>
          <Row>
            <Col
              className={styles.section + (visible ? '' : ' ' + styles.hide)}
              xs={12}
              sm={6}
            >
              <p>{leftTitle}</p>
              <p>{leftText}</p>
            </Col>
            <Col
              className={styles.section + (visible ? '' : ' ' + styles.hide)}
              xs={12}
              sm={6}
            >
              <p>{rightTitle}</p>
              <p>{rightText}</p>
            </Col>
          </Row>
        </div>
      </VisibilitySensor>
    );
  }
}
